<template>
    <div class="mobile-wallets-checkout py-1">
        <div v-if="loading" class="text-center mx-auto mt-4 mb-8">
            <v-progress-circular indeterminate transition="fade-transition" color="blue darken-3" size="30" width="2"></v-progress-circular>
        </div>
        <div v-else-if="checkingOut" class="text-center mx-auto mt-4 mb-8">
            <v-progress-circular indeterminate transition="fade-transition" color="yellow darken-3" size="30" width="2"></v-progress-circular>
        </div>
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

const FAWRY_HOST = {
    staging: 'https://atfawry.fawrystaging.com',
    prod: 'https://www.atfawry.com',
};

function loadStylesheet(href) {
    return new Promise((resolve) => {
        if (document.querySelector(`link[data-fawry-css="${href}"]`)) {
            resolve();
            return;
        }
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        link.setAttribute('data-fawry-css', href);
        // Never block app paint; resolve even on failure so checkout isn't stuck forever
        const done = () => resolve();
        link.onload = done;
        link.onerror = done;
        document.head.appendChild(link);
        // Hard cap so a slow CDN can't hang the wallet UI
        setTimeout(done, 8000);
    });
}

function loadScript(src) {
    return new Promise((resolve, reject) => {
        if (window.FawryPay) {
            resolve();
            return;
        }
        const existing = document.querySelector(`script[data-fawry-js="${src}"]`);
        if (existing) {
            existing.addEventListener('load', () => resolve());
            existing.addEventListener('error', () => reject(new Error('Failed to load Fawry SDK')));
            return;
        }
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = src;
        script.setAttribute('data-fawry-js', src);
        script.onload = () => resolve();
        script.onerror = () => reject(new Error('Failed to load Fawry SDK'));
        document.head.appendChild(script);
    });
}

export default {
    props: {
        amount: {
            required: true,
        },
        staging: {
            type: Boolean,
            default: false,
        }
    },
    data(){
        return {
            loading: false,
            checkingOut: false,
            iframeUrl: null,
            imported: false,
            loadingLibs: false,
            
            chargeRequest: null,
        }
    },
    computed: {
        ...GlobalComputed,
        fawryBase(){
            return this.staging ? FAWRY_HOST.staging : FAWRY_HOST.prod;
        },
    },
    methods: {
        ...GlobalMethods,
        initOrder(){
            if (!this.loading){
                this.loading = true;
                  
                this.$store.dispatch('createFawryOrder', {amount: this.amount}).then(response=>{
                    setTimeout(()=>{
                        this.chargeRequest = response.data;
                        this.loading = false;
                        this.checkout();
                    }, 1000);

                }).catch(e=>{
                    console.error(e)
                    this.loading = false;
                    this.showMsg('حدثت مشكلة أثناء تنفيذ الإجراء، حاول مرة أخرى', 'error');
                })
            }
        },
        importFawryLibs(){
            if (this.imported){
                this.initOrder();
                return;
            }
            if (this.loadingLibs){
                return;
            }
            this.loadingLibs = true;
            this.loading = true;

            const base = this.fawryBase;
            const cssHref = `${base}/atfawry/plugin/assets/payments/css/fawrypay-payments.css`;
            const jsSrc = `${base}/atfawry/plugin/assets/payments/js/fawrypay-payments.js`;

            Promise.all([
                loadStylesheet(cssHref),
                loadScript(jsSrc),
            ]).then(()=>{
                this.imported = true;
                this.loadingLibs = false;
                this.loading = false;
                this.initOrder();
            }).catch(e=>{
                console.error(e);
                this.loadingLibs = false;
                this.loading = false;
                this.showMsg('حدثت مشكلة أثناء تحميل بوابة الدفع، حاول مرة أخرى', 'error');
            });
        },
        checkout(){
            const configuration = {
                locale : "ar",  //default en
                // mode: DISPLAY_MODE.SIDE_PAGE, // eslint-disable-line no-undef
                mode: DISPLAY_MODE.POPUP, // eslint-disable-line no-undef
                // mode: DISPLAY_MODE.SEPERATED, // eslint-disable-line no-undef
            };
            this.checkingOut = true;
            FawryPay.checkout(this.chargeRequest, configuration); // eslint-disable-line no-undef
        }
    },
    mounted(){
       this.importFawryLibs();
    }
}
</script>

<style lang="scss">
.mobile-wallets-checkout{
    .v-messages{
        min-height: 18px!important;
    }
}
</style>
